<template>
  <div class="card shadow-none rounded-0 mb-0">
    <div class="card-body py-1 d-flex align-items-center">
      <h6 class="mb-0 fw-normal">
        <template v-if="ragDb.readableName">База: <span class="fw-semibold">{{ ragDb.readableName }}</span>, страниц: {{ ragPages }}</template>
        <template v-if="chatDocFileName">Загружен файл: <span class="fw-semibold">{{ chatDocFileName }}</span></template>
      </h6>
      <div class="ms-auto d-flex justify-content-center flex-nowrap bg-white p-2">
        <div class="me-3">
          <div class="mb-3">
            <label class="mb-0 mt-1">
              <div class="d-flex flex-fill my-1">
                <div class="form-check-label d-flex me-2">
                  <div>
                    <span class="">Сохранять контекст</span>
                    <div class="text-muted"></div>
                  </div>
                </div>
                <input @change="changeSwitchContext" v-model="user.user.contextEnabled" type="checkbox"
                  name="layout-direction" value="rtl" class="form-check-input cursor-pointer m-0 ms-auto">
              </div>
            </label>
          </div>
        </div>
        <div class="me-2">
          <div class="btn-group">
            <a href="#" class="btn btn-sm dropdown-toggle btn-outline-light" data-bs-toggle="dropdown"
              aria-expanded="true">{{ model
              || 'Выберите модель' }}</a>
            <div class="dropdown-menu" data-popper-placement="bottom-start"
              style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 42px);">
              <a href="#" v-for="m in models" :key="m.name" @click.prevent="model = m.name" class="dropdown-item">{{
                m.name }}</a>
            </div>
          </div>
        </div>
        <div class="mx-1">
          <div class="btn-group">
            <a href="#" class="btn btn-sm dropdown-toggle btn-outline-light" data-bs-toggle="dropdown"
              aria-expanded="true">{{ role
              || 'Выберите роль' }}</a>
            <div class="dropdown-menu" data-popper-placement="bottom-start"
              style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 42px);">
              <a href="#" v-for="r in roles" :key="r.name" @click.prevent="role = r.name" class="dropdown-item">{{
                r.name }}</a>
            </div>
          </div>
        </div>
        <!--
        <div class="mx-1 d-flex justify-content-center flex-nowrap bg-white">
          <div class="form-check form-check-reverse me-2 mt-2">
            <input type="checkbox" class="form-check-input" id="cc_rs_c" checked="" v-model="useVectorDB">
            <label class="form-check-label" for="cc_rs_c">RAG</label>
          </div>
          <div class="">
            <div class="btn-group">
              <a href="#" class="btn btn-sm btn-outline-light dropdown-toggle" data-bs-toggle="dropdown"
                aria-expanded="true">{{ ragDb.readableName
                || 'Выберите базу данных' }}</a>
              <div class="dropdown-menu" data-popper-placement="bottom-start"
                style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 42px);">
                <a href="#" v-for="db in databases" :key="db._id" @click.prevent="ragDb = db" class="dropdown-item">{{
                  db.readableName }} ({{ db.name }})</a>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
  <div class="content-inner">
    <!-- Content area -->
    <div class="content p-0 bg-white">
      <div class="d-flex flex-column justify-content-end h-100">
        <div class="card-body">
          <template v-if="generatedImage?.dataUrl">
            <div class="position-relative">
              <button
                type="button"
                class="btn btn-light btn-sm btn-icon border-transparent rounded-pill position-absolute"
                style="top: 8px; right: 8px; z-index: 2;"
                @click.stop="closeGeneratedImage">
                <i class="ph-x"></i>
              </button>

              <div class="d-flex justify-content-center mb-3">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click.stop="downloadGeneratedImage">
                  Сохранить
                </button>
              </div>

              <div class="d-flex justify-content-center">
                <img
                  :src="generatedImage.dataUrl"
                  alt="generated"
                  class="img-fluid rounded border"
                  style="max-height: 50vh;"
                >
              </div>

            </div>
          </template>
          <template v-else-if="isImageGenerating">
            <div class="d-flex flex-column align-items-center justify-content-center" style="min-height: 240px;">
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="fw-semibold">Генерация изображения...</div>
              <div class="text-muted fs-sm mt-1">Подождите, это может занять несколько минут</div>
              <div class="text-muted fs-sm mt-1">{{ imageGenSeconds }} сек</div>
            </div>
          </template>
          <template v-else>
            <ChatBody :context="context" :AIThinking="AIThinking"></ChatBody>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div class="card shadow-none rounded-0 card-body d-flex flex-column justify-content-end mb-0 p-2">
    <p class="d-flex mb-1" v-if="(user.user.accessRights || []).indexOf('rag') >= 0">
      <button type="button" class="btn btn-link text-muted border-bottom-1"
        :class="showSystemBlock === 'query' ? 'bg-light' : ''" @click.stop="showSystemBlock = 'query'">Ваш
        запрос</button>
      <button type="button" class="btn btn-link text-muted me-2" :class="showSystemBlock === 'rag' ? 'bg-light' : ''"
        @click.stop="showSystemBlock = 'rag'">Запрос с
        RAG</button>
      <button type="button" class="btn btn-link text-muted me-2" :class="showSystemBlock === 'role' ? 'bg-light' : ''"
        @click.stop="showSystemBlock = 'role'">Роль</button>
      <button class="btn btn-secondary btn-icon rounded-pill ms-auto" type="button" @click.stop="switchTextInputRows"><i
          class="ph-arrows-down-up"></i></button>
    </p>
    <template v-if="showSystemBlock === 'query'">
      <div class="form-text text-end">ctrl+Enter для отправки. </div>
      <textarea v-model="userMessage" :rows="textInputRows" class="form-control form-control-content mb-2"
        :disabled="AIThinking" contenteditable=""
        data-placeholder="Пример: напиши 10 целей внедрения автоматизированной системы управления класса ERP"
        @keyup.ctrl.enter="askMakerGPT"
        placeholder="Пример: напиши 10 целей внедрения автоматизированной системы управления класса ERP"
        autofocus></textarea>
      <div class="d-flex justify-content-between mb-0 flex-wrap">
        <!--<div class="d-flex justify-content-between mb-0 d-none d-md-flex">-->
        <div class="d-flex justify-content-between mb-0">
          <div>

          </div>
          <div>
            <a v-if="selectedModel?.imageSupport"
              class="btn btn-light btn-icon border-transparent rounded-pill btn-sm me-1"
              :class="selectedModel?.imageSupport ? '' : 'disabled'" @click="$refs.chatFile.click()">
              <i class="ph-file-png"></i>
              <input type="file" ref="chatFile" @change="handleFileUpload" class="" style="display: none;"
                name="chatFile">
            </a>
            <div class="form-text text-end">{{ imgUrl ? `Файл загружен` : '' }}</div>
          </div>
          <div>
            <a
              class="btn btn-light btn-icon border-transparent rounded-pill btn-sm me-1"
              @click="$refs.chatDocFile.click()">
              <i class="ph-paperclip"></i>
              <input type="file" ref="chatDocFile" @change="handleDocFileUpload" class="" style="display: none;"
                name="chatDocFile">
            </a>
            <div class="form-text text-end">{{ chatDocFile ? `Файл загружен` : '' }}</div>
          </div>
          <div class="mx-3 d-flex justify-content-center flex-nowrap bg-white ms-3">
            <div class="">
              <div class="btn-group dropup dropdown-menu-scrollable-md">
                <a href="#" class="btn btn-sm btn-outline-light dropdown-toggle" data-bs-toggle="dropdown"
                  aria-expanded="false">{{ ragDb.readableName
                  || 'Выберите базу данных' }}</a>
                <div class="dropdown-menu" data-popper-placement="bottom-start"
                  style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 42px);">
                  <a href="#" @click.prevent="ragDb = {}" class="dropdown-item">Не использовать</a>
                  <a
                    href="#" v-for="db in databases"
                    :key="db._id"
                    @click.prevent="ragDb = db"
                    class="dropdown-item"
                    :class="ragDb.readableName === db.readableName ? 'fw-semibold' : ''">{{
                    db.readableName }}<sup v-if="db.type === 'public'">public</sup></a>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item">
                    <div class="mb-2 w-100">
                      <input class="form-range" type="range" name="range" min="0" max="30" v-model="ragPages">
                      <div class="form-text">Загружать страниц <code>{{ ragPages }}</code></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--
            <div class="form-check ms-2 me-2 mt-2">
              <input type="checkbox" class="form-check-input" id="cc_rs_c" checked="" v-model="useVectorDB">
              <label class="form-check-label" for="cc_rs_c">Использовать</label>
            </div>
            -->
          </div>
        </div>
        <div>
          <button
            @click.prevent="generateImage"
            type="button"
            class="btn btn-primary me-2"
            :class="AIThinking || isImageGenerating ? 'disabled' : ''">
            Генерировать изображение
          </button>
          <button @click.prevent="clearContext" type="button" class="btn btn-primary me-2"
            :class="AIThinking || isImageGenerating ? 'disabled' : 'false'">Сбросить диалог</button>
          <button @click.stop="askMakerGPT" type="button" class="btn btn-primary ms-auto"
            :class="AIThinking || isImageGenerating ? 'disabled' : ''">
            Отправить
            <i class="ph-paper-plane-tilt ms-2" :class="{ 'spinner-grow': AIThinking }"></i>
          </button>
        </div>
      </div>
    </template>
    <template v-if="showSystemBlock === 'rag'">
      <div class="d-flex align-items-center mb-2">
        <div class="me-2 flex-fill">
          <div class="form-text text-end">Запрос подмешивания</div>
          <textarea v-model="RAGQuery" :rows="textInputRows" class="form-control form-control-content mb-1"
            contenteditable="" data-placeholder="Type message here and hit enter..."></textarea>
        </div>
        <div class="flex-fill">
          <div class="form-text text-end">Итоговый запрос</div>
          <textarea v-model="systemBlockMessage" :rows="textInputRows" class="form-control form-control-content mb-1"
            contenteditable="" data-placeholder="Type message here and hit enter..."></textarea>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2 me-1">
        <button @click.stop="createSystemBlock" type="button" class="btn btn-primary ms-auto mb-2">
          Загрузить
        </button>
      </div>
    </template>
    <template v-if="showSystemBlock === 'role'">
      <div class="d-flex align-items-center mb-2">
        <div class="me-2 flex-fill">
          <div class="form-text text-end">Роль</div>
          <textarea v-model="customRole" :rows="textInputRows" class="form-control form-control-content mb-1"
            contenteditable="" data-placeholder=""></textarea>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import axios from 'axios'
// import { encode } from 'gpt-tokenizer'

import api from '@/api/maker-gpt'
import showdown from 'showdown'
// import axios from 'axios'
import moment from 'moment'
import ChatBody from '@/components/ChatBody.vue'

// import { ref, watch, computed } from 'vue'
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

const converter = new showdown.Converter()

export default {
  name: 'chatView',
  components: {
    ChatBody
  },
  setup () {
    const store = useStore()
    // const moment = inject('moment')

    const apiKey = ref('')
    const user = computed(() => store.getters.getActiveUser || {})
    const systemMessage = ref('Приложение запущено')
    const userAccessKey = ref('dktC7ihNsHlsLxflAi5bRnUE')
    const AIThinking = ref(false)
    const userMessage = ref('')
    const customRole = ref(user.value.user?.role?.content || '')
    const collection = ref({})
    const useVectorDB = ref(false)
    const serverSchema = ref([])
    const showSystemBlock = ref('query')
    const systemBlockMessage = ref('')
    const RAGQuery = ref('')
    const textInputRows = ref(3)
    const databases = computed(() => store.state.databases || [])
    const ragDb = ref({})
    const chatFile = ref(null)
    const imgUrl = ref(null)
    const chatDocFile = ref(null)
    const chatDocFileContent = ref(null)
    const chatDocFileName = ref(null)
    const ragPages = ref(1)
    const models = computed(() => store.state.models || [])
    const prompt = computed(() => store.state.prompt || '')
    const isImageGenerating = ref(false)
    const generatedImage = ref(null)
    const imageGenSeconds = ref(0)
    let imageGenTimer = null

    const role = computed({
      get: () => store.getters.getActiveUser?.user?.role?.name,
      set: (newRole) => {
        store.dispatch('setUserRole', newRole)
        customRole.value = user.value?.user?.role?.content || ''
      }
    })
    const model = computed({
      get: () => store.getters.getActiveUser?.user?.model,
      set: (newModel) => store.dispatch('setUserModel', newModel)
    })
    const selectedModel = computed(() => {
      return models.value.find(el => el.name === model.value)
    })
    // const userContext =
    // console.log('userContext', userContext.value)
    const context = computed(() => store.getters.getActiveUser?.user?.context || [])
    // if (store.state.activeUser.user) context.value.push(...user.value.user.context)
    userAccessKey.value = user.value.user?.accessKey || ''

    RAGQuery.value = `Используйте приведенные ниже отрывки и историю переписки, чтобы ответить на вопрос пользователя. Данные не относящиеся к вопросу игнорируй.
Если вы не знаешь ответа, скажи, что точно не знаешь, но можешь предложить вот такой ответ и сформируй ответ без учета предоставленных данных.`

    store.commit('addSystemMessage', { type: 'info', message: 'Приложение запущено' })
    /*
    async function loadSchema () {
      // const _serverSchema = await axios.get('http://10.1.1.27:8080/v1/schema')
      try {
        const _serverSchema = await axios.get('https://api.maker-gpt.pro/db/v1/weaviate/schema')
        const { schema } = _serverSchema.data
        serverSchema.value = schema?.classes
        collection.value = serverSchema.value[0]
      } catch (err) {
        console.log(err)
      }
    }
    loadSchema()
    */
    async function doSearch ({ rag, searchText, pages }) {
      const searchResult = {
        text: ''
      }
      // console.log(rag, searchText, pages)
      let apiReply
      switch (rag.backend) {
        case 'vectordb':
          apiReply = await api.queryWeaviateAPI('/v1/weaviate/search', {
            collectionName: rag.name,
            tenant: '',
            searchText,
            pages
          })
          searchResult.text = (apiReply?.objects || []).reduce(
            (summ, el) => {
              let text = '\n' + (el.properties?.data || '')
              text += rag.showSourceDetails
                ? `
Имя базы данных: ${rag.readableName || ''}
Имя документа: ${el.properties.doc_name || ''}
Страница: ${el.properties.chunk_page || ''}`
                : ''
              return summ + text
            }
            , ''
          )
          searchResult.extraData = apiReply?.objects || []
          break
        case 'postgresql':
          apiReply = await api.queryMakerGptAPI('/v1/pg/hybridsearch', {
            tableName: rag.name,
            text: searchText,
            searchText,
            limit: pages
          })
          searchResult.text = (apiReply || []).reduce(
            (summ, el) => {
              return summ + el.data + '\n\n'
            }, '')
          break
        case 'POST':
        case 'GET':
          apiReply = await api.queryMakerGptAPI('/v1/db/urlquery', {
            httpBackend: rag.httpBackend,
            backend: rag.backend,
            searchText
          })
          searchResult.text = apiReply?.text || ''
          searchResult.extraData = apiReply?.extraData || {}
          break
      }
      if (searchResult.extraData && searchResult.extraData[0]?.uuid) {
        const files = await api.queryMakerGptAPI('/v1/system/getfile/uuid', { uuid: searchResult.extraData[0].uuid })
        searchResult.files = files || []
      }
      return searchResult
    }

    async function createSystemBlock () {
      try {
        if (!userMessage.value) throw new Error('Пустой запрос!')
        let _content = userMessage.value
        const searchResult = await doSearch({ rag: ragDb.value, searchText: userMessage.value, pages: ragPages.value })
        if (searchResult.text) _content += `\nПри ответе используй эти данные: \n${searchResult.text}\n`
        systemBlockMessage.value = _content
      } catch (err) {
        console.log(err)
        store.commit('addSystemMessage', { type: 'error', message: err })
      }
    }

    const askMakerGPT = async function () {
      try {
        if (!userMessage.value) throw new Error('Пустой запрос!')
        let _contentText = userMessage.value

        let _roleContent = customRole.value.trim() || store.getters.getRoles.find(el => el.name === role.value)?.role?.content || ''

        let searchResult = null

        const _query = { user: { accessKey: user.value?.user?.accessKey }, content: _contentText, model: model.value }

        if (ragDb.value.readableName) {
          _roleContent += '\n' + (RAGQuery.value || '')
          if (systemBlockMessage.value) {
            _contentText += '\n' + systemBlockMessage.value
          } else {
            searchResult = await doSearch({ rag: ragDb.value, searchText: userMessage.value, pages: ragPages.value })
            if (searchResult.text) _roleContent += `\nПри ответе используй эти данные: \n${searchResult.text}\n`

            _query.files = searchResult?.files || []
            /*
Имя базы данных: ${ragDb.value.readableName || ''}\n
Имя документа: ${searchResult.extraData[0]?.properties.doc_name || ''}\n
Страница: ${searchResult.extraData[0]?.properties.chunk_page || ''}\n
            */
          }
        }

        if (chatDocFileContent.value) _roleContent += `\nзагружен файл: ${chatDocFileName.value}:\n${chatDocFileContent.value}`

        _query.system = [{
          role: 'system',
          content: _roleContent
        }]
        _query.content = imgUrl.value
          ? [
              { type: 'text', text: _contentText },
              {
                type: 'image_url',
                image_url: {
                  url: imgUrl.value
                }
              }
            ]
          : _contentText
        store.commit('addUserContext', {
          role: 'user',
          content: _query.content,
          system: _query.system
        })
        AIThinking.value = true
        const _answer = await api.queryMakerGptAPI_async('/v1/chat/completions/async', _query)
        userMessage.value = ''
        if (imgUrl.value) {
          chatFile.value = null
          imgUrl.value = null
        }
        AIThinking.value = false
        store.commit('addUserContext', {
          role: 'assistant',
          content: _answer.content,
          usage: _answer.usage,
          files: searchResult?.files || []
        })
        store.commit('addSystemMessage', { type: 'info', message: 'Ответ от MakerGPT получен' })
        systemMessage.value = 'Ответ от MakerGPT получен'
        checkContextLength()
      } catch (err) {
        console.log(err)
        store.commit('addSystemMessage', { type: 'error', message: err })
      }
    }

    const buildImageDataUrl = function ({ result, outputFormat }) {
      if (!result || typeof result !== 'string') return ''
      const trimmed = result.trim()
      if (!trimmed) return ''
      if (trimmed.startsWith('data:image/')) return trimmed
      const fmt = (outputFormat || 'png').toLowerCase()
      return `data:image/${fmt};base64,${trimmed}`
    }

    const closeGeneratedImage = function () {
      generatedImage.value = null
      isImageGenerating.value = false
    }

    const startImageGenTimer = function () {
      if (imageGenTimer) clearInterval(imageGenTimer)
      imageGenSeconds.value = 1
      imageGenTimer = setInterval(() => {
        imageGenSeconds.value += 1
      }, 1000)
    }

    const stopImageGenTimer = function () {
      if (imageGenTimer) clearInterval(imageGenTimer)
      imageGenTimer = null
    }

    const clearContext = async function () {
      chatFile.value = null
      imgUrl.value = null
      chatDocFileContent.value = null
      chatDocFileName.value = null
      store.dispatch('clearUserContext')
    }

    const downloadGeneratedImage = function () {
      try {
        if (!generatedImage.value?.dataUrl) throw new Error('Нет изображения для сохранения')
        const dataUrl = generatedImage.value.dataUrl
        const format = (generatedImage.value.format || 'png').toLowerCase()

        const commaIndex = dataUrl.indexOf(',')
        const base64 = commaIndex >= 0 ? dataUrl.slice(commaIndex + 1) : dataUrl
        const mimeMatch = dataUrl.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,/)
        const mime = mimeMatch?.[1] || `image/${format}`

        const byteCharacters = atob(base64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mime })

        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = `generated.${format}`
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(objectUrl)
      } catch (err) {
        console.log(err)
        store.commit('addSystemMessage', { type: 'error', message: err })
      }
    }

    const generateImage = async function () {
      try {
        if (!userMessage.value) throw new Error('Пустой запрос!')
        if (AIThinking.value) throw new Error('Дождитесь завершения ответа модели')
        if (isImageGenerating.value) return true

        generatedImage.value = null
        isImageGenerating.value = true
        startImageGenTimer()

        const commonKey = user.value?.user?.commonKey
        if (!commonKey) throw new Error('Не найден commonKey пользователя')

        const resp = await api.generateImageViaOaiProxy({
          commonKey,
          input: userMessage.value,
          model: 'gpt-5.4',
          async: true
        })
        if (resp?.err) throw new Error(resp.message || 'Ошибка генерации изображения')
        if (resp?.error) throw new Error(resp.error?.message || 'Ошибка генерации изображения')

        const call = Array.isArray(resp?.output)
          ? resp.output.find(o => o?.type === 'image_generation_call') || resp.output[0]
          : null
        const result = call?.result
        const outputFormat = call?.output_format || 'png'
        const dataUrl = buildImageDataUrl({ result, outputFormat })
        if (!dataUrl) throw new Error('Пустой результат генерации изображения')

        generatedImage.value = {
          dataUrl,
          format: outputFormat,
          raw: call
        }
      } catch (err) {
        console.log(err)
        store.commit('addSystemMessage', { type: 'error', message: err })
      } finally {
        isImageGenerating.value = false
        stopImageGenTimer()
      }
    }

    const checkContextLength = function () {
      if (user.value.user.context.length > 10 && user.value.user.context.length % 3 === 0) {
        store.dispatch('showMessage', { text: 'Длинна контекста более 10 сообщений, это может привести к повышенному расходу токенов. Рекомендуем очистить контекст и начать новый диалог', type: 'warning', autoClose: 5000 })
      }
    }

    const MarkdownToHTML = function (text) {
      return converter.makeHtml(text)
    }

    const switchTextInputRows = function () {
      textInputRows.value = textInputRows.value > 10 ? 5 : 15
    }

    async function handleDocFileUpload () {
      const allowedFiles = ['pdf', 'doc', 'docx', 'txt', 'md', 'csv', 'xlsx', 'xls', 'xml', 'json']
      const fileExtension = chatDocFile.value.files[0].name.split('.').pop().toLowerCase()
      if (allowedFiles.indexOf(fileExtension.toLowerCase()) === -1 || chatDocFile.value.files[0].siza > 5000000) {
        store.dispatch('showMessage', { text: 'Ошибка загрузки файла - допустимы pdf, doc, docx. Размер до 5 мегабайт.', type: 'error' })
        chatDocFile.value = null
        return true
      }
      try {
        const formData = new FormData()
        formData.append('file', chatDocFile.value.files[0])
        formData.append('title', 'from maker gpt')
        formData.append('fileName', chatDocFile.value.files[0].name)
        formData.append('tags', `makergpt,${user.value?.user?.accessKey}`)
        const apiReply = await api.queryMakerGptAPI('/v1/pg/docs/upload', formData)
        if (apiReply?.processedDoc?.content) {
          store.dispatch('showMessage', { text: 'Файл добавлен к  диалогу', type: 'info', autoClose: 3000 })
          chatDocFileContent.value = apiReply?.processedDoc?.content
          chatDocFileName.value = apiReply?.processedDoc?.originalName
        } else {
          store.dispatch('showMessage', { text: 'Ошибка прикрепления файла к записи базы данных.', type: 'error', autoClose: 3000 })
        }
        chatDocFile.value = null
      } catch (err) {
        console.log(err)
      }
    }

    async function handleFileUpload () {
      const allowedFiles = ['png', 'jpeg', 'gif', 'webp', 'jpg']
      const fileExtension = chatFile.value.files[0].name.split('.').pop().toLowerCase()
      if (allowedFiles.indexOf(fileExtension.toLowerCase()) === -1 || chatFile.value.files[0].siza > 5000000) {
        store.dispatch('showMessage', { text: 'Ошибка загрузки файла - допустимы png, jpeg, gif, webp. Размер до 5 мегабайт.', type: 'error' })
        chatFile.value = null
        imgUrl.value = null
        return true
      }
      const formData = new FormData()
      formData.append('file', chatFile.value.files[0])
      const apiRply = await api.queryMakerGptAPI('/v1/system/upload/img', formData, {
        'Content-Type': 'multipart/form-data'
      }
      )
      imgUrl.value = apiRply.url
      chatFile.value = null
    }

    const changeSwitchContext = function () {
      store.dispatch('switchContext', user.value.user.contextEnabled)
    }

    watch(prompt, (newValue, oldValue) => {
      if (newValue && newValue !== oldValue) userMessage.value += prompt.value
    })

    return {
      apiKey,
      userAccessKey,
      context,
      user,
      usage: computed(() => store.state.activeUser.usage || {}),
      AIThinking,
      userMessage,
      askMakerGPT,
      clearContext,
      systemMessage,
      MarkdownToHTML,
      model,
      role,
      models,
      roles: computed(() => store.getters.getRoles || []),
      collection,
      serverSchema,
      useVectorDB,
      moment,
      showSystemBlock,
      systemBlockMessage,
      RAGQuery,
      createSystemBlock,
      textInputRows,
      switchTextInputRows,
      customRole,
      databases,
      ragDb,
      chatFile,
      chatDocFile,
      chatDocFileName,
      chatDocFileContent,
      handleFileUpload,
      imgUrl,
      selectedModel,
      changeSwitchContext,
      ragPages,
      handleDocFileUpload,
      isImageGenerating,
      generatedImage,
      generateImage,
      closeGeneratedImage,
      downloadGeneratedImage,
      imageGenSeconds
    }
  },
  mounted () {
  }
}

</script>

<style>
.selectNone {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
